"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAllegroProject = transformAllegroProject;
const TransformOrchestrator_1 = require("../../../Shared/HierarchicalTransformer/TransformOrchestrator");
const TransformProject_1 = require("../../../Shared/HierarchicalTransformer/TransformObjects/TransformProject");
const TransformImageExtraction_1 = require("../../../Shared/HierarchicalTransformer/TransformObjects/TransformImageExtraction");
const AllegroTransformProjectGenerator_1 = require("./Generators/AllegroTransformProjectGenerator");
const AllegroTransformSchematicGenerator_1 = require("./Generators/AllegroTransformSchematicGenerator");
const AllegroTransformComponentGenerator_1 = require("./Generators/AllegroTransformComponentGenerator");
const AllegroTransformModuleGenerator_1 = require("./Generators/AllegroTransformModuleGenerator");
const AllegroTransformNetWireGenerator_1 = require("./Generators/AllegroTransformNetWireGenerator");
const AllegroTransformOffPageConnectorGenerator_1 = require("./Generators/AllegroTransformOffPageConnectorGenerator");
const AllegroTransformGlobalSymbolGenerator_1 = require("./Generators/AllegroTransformGlobalSymbolGenerator");
const AllegroTransformGraphicsGenerator_1 = require("./Generators/AllegroTransformGraphicsGenerator");
function transformAllegroProject(rootContext) {
    const transformer = new TransformOrchestrator_1.TransformOrchestrator({
        generators: [
            new AllegroTransformProjectGenerator_1.AllegroTransformProjectGenerator(),
            new AllegroTransformSchematicGenerator_1.AllegroTransformSchematicGenerator(),
            new AllegroTransformComponentGenerator_1.AllegroTransformComponentGenerator(),
            new AllegroTransformModuleGenerator_1.AllegroTransformModuleGenerator(),
            new AllegroTransformNetWireGenerator_1.AllegroTransformNetWireGenerator(),
            new AllegroTransformOffPageConnectorGenerator_1.AllegroTransformOffPageConnectorGenerator(),
            new AllegroTransformGlobalSymbolGenerator_1.AllegroTransformGlobalSymbolGenerator(),
            new AllegroTransformGraphicsGenerator_1.AllegroTransformGraphicsGenerator(),
        ],
    });
    const projectModels = transformer.transform(rootContext, TransformProject_1.TransformProject);
    const imageExtractionObjects = transformer.getRegistry().getPrimaries(TransformImageExtraction_1.TransformImageExtraction);
    const extractedImages = imageExtractionObjects.map((obj) => obj.compiled);
    return { projectModels, extractedImages };
}
//# sourceMappingURL=AllegroOrchestratedTransformer.js.map